export default function useConvertNumberToTimeText(hour: number): string {
  if (hour > 24) {
    hour -= 24;
  }
  if (hour < 10) {
    return `0${hour}:00`;
  }
  return `${hour}:00`;
}
